<template>
  <div>
    <v-app-bar height="88" color="white">
      <v-toolbar-title class="text-h5 text-uppercase">
        <v-img class="mt-2 ml-11" src="./images/e360_Logo.svg" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <MessageCenterUserButton
        @openMessagesCenter="dialog = true"
        v-if="!showWarningBanner && !isAllowAnonymous && userCanRead && !isReadOnlyUser"
      />
      <!-- <BreadCrumbs /> -->
      <WarningBanner v-if="showWarningBanner && !isAllowAnonymous" />
    </v-app-bar>
    <MessageCenterDialog :dialog="dialog" @closeDialog="dialog = false" />
  </div>
</template>
<script>
// const BreadCrumbs = () => import('@/Core.UI.Domain/Components/BreadCrumbs.vue')
import WarningBanner from '@/Core.UI.Domain/Components/WarningBanner.vue';

import MessageCenterDialog from '@/Core.Service.Domain/MessageCenter/Users/Components/MessageCenterDialog.vue';

import MessageCenterUserButton from '@/Core.Service.Domain/MessageCenter/Users/Components/MessageCenterUserButton.vue';

import { DateTime } from 'luxon';

export default {
  name: 'AppBar',

  components: {
    // BreadCrumbs,
    WarningBanner,
    MessageCenterDialog,
    MessageCenterUserButton,
  },

  computed: {
    isAllowAnonymous() {
      return this.$route.meta.allowAnonymous;
    },

    userCanRead() {
      return this.$can('read', 'message-center');
    },

    isReadOnlyUser() {
      return this.$store.getters['session/isReadOnlyUser'];
    },
  },

  created() {
    this.hideBannerAtPSTTime();
  },

  data: () => ({
    showWarningBanner: false,
    dialog: false,
    targetDate: '2024-01-01',
    hour: 20,
    minute: 0,
  }),

  methods: {
    hideBannerAtPSTTime() {
      const currentDate = DateTime.now().setZone('America/Los_Angeles');

      if (currentDate.toFormat('yyyy-MM-dd') > this.targetDate) {
        return;
      }

      const checkTimeInterval = 30 * 1000;

      const checkTime = () => {
        const nowPST = DateTime.now().setZone('America/Los_Angeles');
        const targetTime = nowPST.set({
          hour: this.hour,
          minute: this.minute,
          second: 0,
          millisecond: 0,
        });

        if (nowPST < targetTime) {
          this.showWarningBanner = true;
        } else {
          this.showWarningBanner = false;
        }

        setTimeout(checkTime, checkTimeInterval);
      };

      checkTime();
    },
  },
};
</script>
<style lang="scss" scoped>
.v-toolbar {
  &__content {
    width: 50%;
  }
}
.v-img :deep(.v-img__img) {
  width: 150px;
}
</style>
